<template>
  <router-link :to="route" class="main-slide" :class="{ 'main-slide--trend': trend }" v-if="data">
    <div class="ratio-container">
      <ImgComponent class="main-slide__image" :src="data.src" width="1200" height="800" />
      <div class="main-slide__content">
        <div class="main-slide__content-bottom">
          <time :datetime="data.published_at | robotDate" v-if="data.published_at" class="main-slide__date">
            {{ data.date | formatDate }}
          </time>
          <span v-if="data.title" class="main-slide__title">{{ data.title }}</span>
          <span v-if="data.subtitle" class="main-slide__subtitle">{{ data.subtitle }}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "SlideComponent",
  props: {
    data: Object,
    trend: Boolean,
    isShare: Boolean,
  },
  computed: {
    route() {
      if (this.isShare) {
        return { name: "catalog", query: { share_id: this.data.id } };
      }
      return { name: "news_item", params: { id: this.data.id } };
    },
  },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/ratio.styl"
@import "~@/styles/mixins/maxlines.styl"
.main-slide {
  ratio(393, 350)
  background: var(--white);
  position relative
  overflow hidden
  display inline-flex
  align-items flex-start
  justify-content flex-start
  width 100%
  max-width 100%
  max-height 100%
  //max-width 413px

  &:hover &__image {
    filter brightness(0.8)
  }

  &:after {
    content ""
    absolute top right bottom left
    background: linear-gradient(8.3deg, var(--black) 0%, rgba(0, 0, 0, 0) 47.58%);
    opacity: 0.5;
  }

  &--trend {
    ratio(404, 310)
    display flex

    .main-slide__content {
      padding 10px
      border none
    }
  }

  &__content {
    absolute top right bottom left
    z-index 2
    margin 10px
    padding 15px
    border-radius: var(--main_radius)
    display flex
    flex-direction column
    justify-content space-between
    color: var(--white);
    cursor pointer
    +below(990px) {
      margin 6px
      padding 8px
    }

    &-top
    &-bottom {
      display flex
      flex-direction column
      align-items flex-start
      gap 5px
    }

    &-bottom {
      margin-top auto
    }
  }

  &__brand {
    background: var(--white)
    border-radius: var(--small_radius)
    display flex
    justify-content center
    align-items center
    width 60px
    height 30px
    margin-bottom: 5px;
    +below(840px) {
      width 55px
      height: 25px
      border-radius: 5px;
      margin-bottom: 0;
    }
  }

  &__tag {
    font-size: 10px;
    line-height: 110%
    padding 3px 7px
    border-radius: var(--small_radius)
    +below(840px) {
      border-radius 8px
      line-height 1
    }

    //&--new {
    //  background var(--green)
    //}
    //
    //&--discount {
    //  background var(--yellow)
    //  color: var(----main-color)
    //}
    //
    //&--hit {
    //  background var(--purple)
    //}
    //
    //&--sell {
    //  background var(--red)
    //}
  }

  &__title {
    font-weight: 700;
    font-size: 1.5em
    line-height: 1.16
    display: flex;
    align-items: center;
    margin 0
    maxlines(2)
    +below(840px) {
      font-size: 1em
    }
  }

  &__subtitle {
    +below(1050px) {
      font-size 0.875em
    }
    +below(840px) {
      font-size: 0.75em
      line-height: 120%;
    }
  }

  &__date {
    font-size: 10px;
    line-height: 110%
  }

  &__image {
    width 100%
    height 100%
    object-fit cover
    object-position center
    transition var(--transition)
  }
}
</style>
